import React, { Component } from 'react';
import PilotForm from './PilotForm';
import { getPilot, updatePilot, getIncompletePilot } from './api';
import EditPage from './EditPage';

class EditPilotPage extends Component {
  render() {
    return (
      <EditPage
        getItem={getPilot}
        saveItem={updatePilot}
        formComponent={PilotForm}
        getNextItem={getIncompletePilot}
        type={`pilots`}
        {...this.props}
      />
    );
  }
}

export default EditPilotPage;



// WEBPACK FOOTER //
// ./src/EditPilotPage.js